/* eslint-disable no-restricted-globals */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useContext, useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import ImageUploader from './common/UploadImage';
import Input from './common/Input';
import { CloudArrowUp, Images as ImagesIcon, Trash3, Link45deg, FileEarmarkPdf } from 'react-bootstrap-icons';
import { CoreContext } from '../context/core-context';
import { AuthContext } from '../context/auth-context';

import 'react-toastify/dist/ReactToastify.css';

const Images = () => {
    const coreContext = useContext(CoreContext);
    const authContext = useContext(AuthContext);
    const [selectedImages, setSelectedImages] = useState([]);
    const [uploadButtonDisabled, setUploadButtonDisabled] = useState(true);

    const fetchClient = () => {
        coreContext.fetchSelfImages(authContext.itemId);
    };

    const onImagesSelected = (pictures) => {
        setSelectedImages(pictures);
        if (pictures.length > 0) setUploadButtonDisabled(false); else setUploadButtonDisabled(true);
    };

    const onImagesUploadHandler = async () => {
        const count = selectedImages.length;
        if (count === 0) return;
        let counter = 0;

        for await (const image of selectedImages) {
            ++counter;
            const formData = new FormData();
            formData.append('itemId', authContext.itemId);
            formData.append('pageId', coreContext.page.id);
            formData.append('image', image, image.name);
            formData.append('userId', authContext.userId);
            formData.append('itype', 'image');
            coreContext.uploadImage(formData, authContext.itemId, coreContext.page.id);

            if (counter === count) {
                setTimeout(() => {
                    setSelectedImages([]);
                    coreContext.fetchSelfImages(authContext.itemId);
                }, 2000);
            }
        }
    };

    const deleteImage = (id) => {
        coreContext.deleteImage(id);
        deleteNotify();
        setTimeout(() => {
            fetchClient();
        }, 500);
    };

    const notify = () => toast.success("Image URL copied to clipboard!");
    const deleteNotify = () => toast.info("Asset deleted successfully");

    const copyURL = (url) => {
        const aux = document.createElement("input");
        aux.setAttribute("value", url);
        document.body.appendChild(aux);
        aux.select();
        document.execCommand("copy");
        document.body.removeChild(aux);
        notify();
    };

    useEffect(fetchClient, []);

    const imagesList = coreContext.client?.images || [];

    const renderImages = () => {
        if (!imagesList || imagesList.length === 0) {
            return (
                <div className="col-12 text-center py-5" style={{ color: '#94a3b8' }}>
                    <ImagesIcon size={48} style={{ opacity: 0.5, marginBottom: '12px' }} />
                    <p style={{ fontSize: '1rem', fontWeight: 500 }}>No images or documents uploaded yet.</p>
                </div>
            );
        }

        return imagesList.map((image, index) => {
            const isPdf = image.url && image.url.toLowerCase().includes('.pdf');
            const fullUrl = "http://" + image.url;
            let src;
            if (isPdf)
                src = 'https://node-websites.siddhantait.com/images/pdfimage.png';
            else
                src = fullUrl;

            return (
                <div key={image.id || image.url || index} className='col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-4'>
                    <div
                        style={{
                            background: '#ffffff',
                            borderRadius: '14px',
                            border: '1px solid #e2e8f0',
                            padding: '12px',
                            display: 'flex',
                            flexDirection: 'column',
                            height: '100%',
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
                            transition: 'all 0.25s ease',
                            position: 'relative'
                        }}
                        className="asset-card"
                    >
                        {/* File Type Pill */}
                        <div style={{ position: 'absolute', top: '18px', left: '18px', zIndex: 5 }}>
                            <span
                                className={`badge ${isPdf ? 'bg-danger' : 'bg-primary'}`}
                                style={{
                                    fontSize: '11px',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '4px',
                                    boxShadow: '0 2px 6px rgba(0,0,0,0.1)'
                                }}
                            >
                                {isPdf ? <FileEarmarkPdf size={11} /> : <ImagesIcon size={11} />}
                                {isPdf ? 'PDF' : 'IMAGE'}
                            </span>
                        </div>

                        {/* Thumbnail Container */}
                        <div
                            onClick={() => window.open(fullUrl, '_blank')}
                            style={{
                                width: '100%',
                                height: '185px',
                                borderRadius: '10px',
                                background: '#f8fafc',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginBottom: '12px',
                                border: '1px solid #f1f5f9',
                                cursor: 'pointer',
                                padding: '8px',
                                overflow: 'hidden'
                            }}
                            title="Click to view full size in new tab"
                        >
                            <img
                                alt={image.alt || (isPdf ? 'PDF Document' : 'Website Image')}
                                src={src}
                                loading="lazy"
                                style={{
                                    maxWidth: '100%',
                                    maxHeight: '100%',
                                    width: 'auto',
                                    height: 'auto',
                                    objectFit: 'contain',
                                    borderRadius: '6px',
                                    display: 'block'
                                }}
                            />
                        </div>

                        {/* URL & Action Bar */}
                        <div style={{ marginTop: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
                            <button
                                type="button"
                                onClick={() => copyURL(fullUrl)}
                                className="btn btn-secondary btn-sm"
                                style={{
                                    flex: 1,
                                    fontSize: '12px',
                                    padding: '6px 10px',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    justifyContent: 'center',
                                    gap: '5px'
                                }}
                                title="Click to copy full asset URL"
                            >
                                <Link45deg size={15} style={{ flexShrink: 0 }} />
                                <span>Copy Link</span>
                            </button>

                            <button
                                onClick={() => deleteImage(image.id)}
                                type="button"
                                className="btn btn-danger btn-sm"
                                style={{ padding: '6px 10px', flexShrink: 0 }}
                                title="Delete this asset permanently"
                            >
                                <Trash3 size={13} />
                            </button>
                        </div>
                    </div>
                </div>
            );
        });
    };

    return (
        <div className='container-fluid px-4 py-2'>
            {/* Page Header Banner */}
            <div className="page-header-banner">
                <div>
                    <h2 className="page-header-title">
                        <ImagesIcon className="text-primary" /> Media & Documents Library
                    </h2>
                    <p className="page-header-subtitle">
                        Upload, manage and organize image assets and PDF documents for your website
                    </p>
                </div>
                <div className="d-none d-md-flex align-items-center gap-2">
                    <span className="badge bg-primary" style={{ fontSize: '0.85rem', padding: '0.5rem 1rem' }}>
                        {imagesList.length} Total Files
                    </span>
                </div>
            </div>

            {/* Upload Card */}
            <div className="card mb-4">
                <div className="card-header-modern">
                    <h4>
                        <CloudArrowUp className="text-primary" /> Upload New Assets
                    </h4>
                </div>
                <div className="card-body">
                    <ImageUploader
                        onImagesSelected={onImagesSelected}
                        maxWidthOrHeight='1920'
                        pictures={selectedImages}
                    />

                    <div className="d-flex align-items-center gap-3 mt-3">
                        <Input
                            value={selectedImages.length > 0 ? `Upload ${selectedImages.length} Selected File(s)` : 'Upload Images / Docs'}
                            onClick={onImagesUploadHandler}
                            disabled={uploadButtonDisabled}
                            elementType='button'
                            variant='primary'
                        />
                        {coreContext.renderLoader()}
                        {coreContext.message && (
                            <Input variant='danger' label={coreContext.message} elementType='label' />
                        )}
                    </div>
                </div>
            </div>

            {/* Media Gallery Card */}
            <div className="card">
                <div className="card-header-modern">
                    <h4>
                        <ImagesIcon className="text-primary" /> Website Media Assets
                    </h4>
                    <span className="badge bg-success">
                        {imagesList.length} Files Available
                    </span>
                </div>
                <div className="card-body">
                    <div className="row">
                        {renderImages()}
                    </div>
                </div>
            </div>

            <ToastContainer
                position="top-center"
                autoClose={1800}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                pauseOnHover
            />
        </div>
    );
};

export { Images };